//AUTH
export const SIGNIN_USER = "signin_user"
export const SIGNUP_USER = "signup_user"
export const AUTH_LOADING = "auth_loading"
export const AUTH_SIGNUP = "auth_signup"
export const AUTH_SIGNIN = "auth_signin"
export const SIGNOUT_USER = "signout_user"
export const AUTH_SIGNIN_ERROR = "auth_signin_error"
export const AUTH_SIGNUP_ERROR = "auth_signup_error"
export const AUTH_ERROR = "auth_error"
export const CHANGE_THEME = "change_theme"

//USER
export const USER_LOADING = "user_loading"
export const USER_SUCCESS = "user_success"
export const USER_ERROR = "user_error"
export const ADD_FRIEND_REQUEST = "add_friend_request"
export const FRIEND_REQUEST_ACCEPT = "friend_request_accept"
export const FRIEND_REQUEST_DELETE = "friend_request_delete"
export const UN_FRIEND_REQUEST = "un_friend_request"
export const ALL_USERS = "all_users"

//POST
export const POSTS_LOADING = "posts_loading"
export const POSTS_GET_ALL = "posts_get_all"
export const POSTS_CREATE = "posts_create"
export const POSTS_ERROR = "posts_error"
export const POSTS_SUCCESS = "posts_success"

//BLOG
export const BLOG_LOADING = "blogs_loading"
export const BLOG_GET_ALL = "blogs_get_all"
export const BLOG_CREATE = "blogs_create"
export const BLOG_ERROR = "blogs_error"
export const BLOG_SUCCESS = "blogs_success"

//NOTICES
export const NOTICE_LOADING = "notice_loading"
export const NOTICE_ERROR = "notice_error"
export const NOTICE_GET = "notice_get"

//POLL
export const POLL_LOADING = "poll_loading"
export const POLL_GET_ALL = "poll_get_all"
export const POLL_ERROR = "poll_error"
export const POLL_CREATE = "poll_create"

//Ads
export const ADS_LOADING = "ads_loading"
export const ADS_GET_ALL = "ads_get_all"
export const ADS_ERROR = "ads_error"
